// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton_container__2UOq9","bar1":"BackButton_bar1__ApUfV","bar2":"BackButton_bar2__2r4Lm"};